export function Header({ children }) {
  return <div className="text-3xl text-cobalt displayText font-semibold">{children}</div>;
}
